import { render, staticRenderFns } from "./PrimeGrid.vue?vue&type=template&id=8ddda02a"
import script from "./PrimeGrid.vue?vue&type=script&lang=js"
export * from "./PrimeGrid.vue?vue&type=script&lang=js"
import style0 from "./PrimeGrid.vue?vue&type=style&index=0&id=8ddda02a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports